/**
 * Centralized Color Palette
 *
 * This palette bridges legacy Bootstrap 3 colors with modern MUI theming.
 * Colors are derived from bootstrap-variables.less for consistency.
 */

export const palette = {
  // Primary brand colors (from Bootstrap 3)
  primary: {
    main: '#95b417',      // @brand-primary - Mashie green
    light: '#a8c535',     // Lighter variant
    dark: '#7a9512',      // Darker variant
    contrastText: '#fff',
  },

  // Secondary colors
  secondary: {
    main: '#375382',      // @brand-links - Dark blue
    light: '#4a6ba0',
    dark: '#2a4063',
    contrastText: '#fff',
  },

  // Success state
  success: {
    main: '#8ec549',      // @brand-success
    light: '#a5d46d',
    dark: '#6fa036',
    contrastText: '#fff',
  },

  // Info state
  info: {
    main: '#2196f3',      // MUI blue for info
    light: '#64b5f6',
    dark: '#1976d2',
    contrastText: '#fff',
  },

  // Warning state
  warning: {
    main: '#f0ad4e',      // @brand-warning
    light: '#f4c374',
    dark: '#ec971f',
    contrastText: '#000',
  },

  // Error/Danger state
  error: {
    main: '#d9534f',      // @brand-danger
    light: '#e17572',
    dark: '#c9302c',
    contrastText: '#fff',
  },

  // Grayscale (from Bootstrap 3)
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',        // @gray-lighter
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#999999',        // @gray-light
    600: '#757575',
    700: '#555555',        // @gray
    800: '#333333',        // @gray-dark
    900: '#222222',        // @gray-darker
  },

  // Background colors
  background: {
    default: '#fafafa',
    paper: '#fff',
  },

  // Text colors
  text: {
    primary: '#222222',    // @gray-darker
    secondary: '#555555',  // @gray
    disabled: '#999999',   // @gray-light
  },

  // Additional semantic colors
  divider: '#dddddd',

  // Form state backgrounds (from Bootstrap alerts)
  states: {
    success: {
      bg: '#dff0d8',
      text: '#3c763d',
      border: '#d6e9c6',
    },
    info: {
      bg: '#E9ED97',
      text: '#000000',
      border: '#d0d45e',
    },
    warning: {
      bg: '#fcf8e3',
      text: '#8a6d3b',
      border: '#faebcc',
    },
    error: {
      bg: '#f2dede',
      text: '#a94442',
      border: '#ebccd1',
    },
  },
} as const;

export type Palette = typeof palette;
